import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Table } from 'react-bootstrap';
import '../css/main.css';

export default class MaintenanceFixComponent extends React.Component {

    // constructor(props) {
    //     super(props);
    // }

    componentWillMount() {
        this.props.findFixableMCases();
    }

    fixingMaintenanceCase(mcase) {
        this.props.assignModifyingTarget(mcase);
        hashHistory.push("/fixingCards");
    }

    appendMaintenanceDetails(mcase) {
        this.props.assignModifyingTarget(mcase);
        hashHistory.push("/fixingAppend");
    }


    render() {

        let caseStatus = function (statusKey) {
            switch (statusKey) {
                case 'MODIFYING': return '確認中';
                case 'REFINED': return '未開工';
                case 'FIXING': return '維修中';
                case 'FIXED': return '完成維修';
                default: return '';
            }
        }

        let highlight = function (statusKey) {
            switch (statusKey) {
                case 'MODIFIED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFE8BF",//yellow
                        verticalAlign: "middle"
                    };
                case 'REFINED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",//red
                        verticalAlign: "middle"
                    };
                case 'FIXING':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",//red
                        verticalAlign: "middle"
                    };
                case 'FIXED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#A2FF91",//green
                        verticalAlign: "middle"
                    };
                default:
                    return {};
            }
        }

        let highlightClassName = function (statusKey) {
            switch (statusKey) {
                case 'MODIFIED':
                    return "highlight-brown";
                case 'REFINED':
                    return "highlight-red";
                case 'FIXING':
                    return "highlight-red";
                case 'FIXED':
                    return "highlight-green";
                default:
                    return '';
            }
        }

        let alignCenter = {
            textAlign: "center",
            verticalAlign: "middle"
        }
        return (
            <div>
                <h4>維修作業</h4><span hidden>MaintenanceFixComponent </span>
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>訂單編號</th>
                            <th>客戶</th>
                            <th>註記</th>
                            <th>維修</th>
                            <th>狀態</th>
                            <th>建立時間</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.response.get('cases').map(
                            (item, index) =>
                                <tr key={index}>
                                    <td style={alignCenter}>
                                        {item.orderId}
                                    </td>
                                    <td style={alignCenter}>
                                        {item.customer.customerName}
                                    </td>
                                    <td style={alignCenter}>
                                        {item.note}
                                    </td>
                                    <td style={alignCenter}>
                                        <Button bsStyle="success"
                                            onClick={(event) => { this.fixingMaintenanceCase(item); }} >開始維修</Button>&nbsp;&nbsp;
                                        <Button bsStyle="warning"
                                            onClick={(event) => { this.appendMaintenanceDetails(item); }} >增補項目</Button>
                                    </td>
                                    <td style={highlight(item.status)}
                                        className={highlightClassName(item.status)} >
                                        {caseStatus(item.status)}
                                    </td>
                                    <td style={alignCenter}>
                                        {new Date(item.createTime).toLocaleDateString()}
                                    </td>
                                </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceFixComponent.jsx